import { clsx } from "clsx";
import type { ComponentProps } from "react";

import { Button } from "@shared/ui/button";
import { Icon, type IconNameType } from "@shared/ui/icon";
import { Toggle } from "@shared/ui/toggle";
import { Body } from "@shared/ui/typography";
import { mod } from "@shared/utils";

import s from "./filter-toggle.module.scss";

export type FilterToggleProps = ComponentProps<"div"> & {
  className?: string;
  isActive: boolean;
  onClick: () => void;
  label?: string;
  icon?: IconNameType;
  "aria-label"?: string;
  variant?: "default" | "white";
};

export const FilterToggle = (props: FilterToggleProps) => {
  const {
    className,
    isActive,
    onClick,
    label,
    icon,
    "aria-label": ariaLabel = "toggle-filter",
    variant = "default",
  } = props;

  const mods = mod(s, {
    variant,
  });

  return (
    <Button
      className={clsx(s.root, className, mods)}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <span className={s.labelWrapper}>
        {icon && <Icon name={icon} className={s.icon} />}
        <Body size="uppercase" weight="semiBold">
          {label}
        </Body>
      </span>
      <Toggle isActive={isActive} variant={variant} />
    </Button>
  );
};

FilterToggle.displayName = "FilterToggle";
